import { DirectionalHint, Stack, TooltipHost } from '@fluentui/react';
import { FormHookTextField } from 'common/components/FormHooksFields';
import { FormHookCheckBox } from 'common/components/FormHooksFields/FormHookCheckBox';
import React from 'react';
import { useStyles } from './index.styles';

export const BasicForm: React.FC = () => {
  const styles = useStyles();
  const HINT_TEXT = 'Users have access only to entries they have created.';

  return (
    <Stack
      tokens={{
        padding: 20,
        childrenGap: 10,
      }}
      className={styles.container}
    >
      <Stack
        horizontal
        tokens={{
          childrenGap: 15,
        }}
      >
        <Stack
          className={styles.fieldContainer}
          tokens={{
            childrenGap: 15,
          }}
        >
          <FormHookTextField label="Name" name="name" required />
          <FormHookTextField label="Description" name="description" />
          <TooltipHost content={HINT_TEXT} directionalHint={DirectionalHint.topLeftEdge}>
            <FormHookCheckBox
              label="My Transactions Only"
              name="isAccessOnlyToCreatedRows"
            />
          </TooltipHost>
        </Stack>
      </Stack>
    </Stack>
  );
};
